import React from 'react';

type Tab = 'overview' | 'tasks' | 'comments' | 'settings';

type Props = {
  activeTab: Tab;
  setActiveTab: (t: Tab) => void;
  tasksCount: number;
  commentsCount: number;
};

export default function TabsNav({ activeTab, setActiveTab, tasksCount, commentsCount }: Props) {
  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-8 px-6">
        <button onClick={() => setActiveTab('overview')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'overview' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>Visão Geral</button>
        <button onClick={() => setActiveTab('tasks')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'tasks' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>Tarefas ({tasksCount})</button>
        <button onClick={() => setActiveTab('comments')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'comments' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>Comentários ({commentsCount})</button>
        <button onClick={() => setActiveTab('settings')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'settings' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}><i className="ri-settings-line mr-2"></i>Configurações</button>
      </nav>
    </div>
  );
}